// Store Imports
import { computed } from '@angular/core'
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals'
import { CheckinFlow, readCheckinFlow, saveCheckinFlow } from './checkin-flow-preference.util'

export type { CheckinFlow }

interface UiState {
	showSidenav: boolean
	checkinFlow: CheckinFlow
}

const initialState = (): UiState => ({
	showSidenav: false,
	// Persisted choice; the default is the legacy flow until the user opts into the new one
	checkinFlow: readCheckinFlow(),
})

export const UiStore = signalStore(
	{ providedIn: 'root' },
	withState(initialState),
	withComputed(({ checkinFlow }) => ({
		isNewCheckinFlow: computed(() => checkinFlow() === 'new'),
	})),
	withMethods((store) => ({
		openSidenav: (): void => {
			patchState(store, (_state: UiState) => ({ showSidenav: true }))
		},
		closeSidenav: (): void => {
			patchState(store, (_state: UiState) => ({ showSidenav: false }))
		},
		setCheckinFlow: (checkinFlow: CheckinFlow): void => {
			patchState(store, { checkinFlow })
			saveCheckinFlow(checkinFlow)
		},
	}))
)
